import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="w-14 h-14 mx-auto text-slate-500" />
      <h1 className="font-display text-3xl font-bold text-white mt-6">Pagamento cancelado</h1>
      <p className="text-slate-400 mt-2">Nenhuma cobrança foi realizada. Você pode assinar quando quiser pelo painel.</p>
      <Button asChild className="mt-8 bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="payment-cancel-dashboard">
        <Link to="/gestor">Voltar ao painel</Link>
      </Button>
    </div>
  );
}
